export const FEATURE_NAME = '@zerops/zerops/feature/log-dialog';
